import React from "react";
import PartnerBanner from "./partners";
import * as E from "../elementor";
import parse from "html-react-parser";
import SmoothScrollLink from "./transition/smooth-scroll-link";
import ArrowCircleDown from "../images/arrow-circle-down.svg";
import RulaBadge from "@pathccm/rula-ui/badge";
interface LandscapeHeroProps {
  section: E.Section;
}

const LandscapeHero = ({ section }: LandscapeHeroProps) => {
  const {
    heading = [],
    textEditor = [],
    button = [],
    image = [],
  } = E.collect(section);
  const partnerSection = section?.cols[0].elements.find(
    (e) => e instanceof E.Section
  ) as unknown as E.Section;
  const ctaIsScrollLink =
    button[0]?.link !== undefined && button[0]?.link.includes("#");

  return (
    <header className="landscape-hero">
      <div className="landscape-hero-rula">
        <div className="landscape-hero-content">
          <div className="landscape-hero-left-col">
            <RulaBadge style="Info" size="Small" icon="Shield" className="landscape-hero-badge">
              {parse(textEditor[0]?.text() || "")}
            </RulaBadge>
            <h1 className="hero-headline">{parse(heading[0]?.title || "")}</h1>
            <p className="landscape-hero-subheadline">
              {parse(textEditor[1]?.text() || "")}
            </p>
            <div className="landscape-hero-cta-wrapper">
              {button[0] ? (
                ctaIsScrollLink ? (
                  <div>
                    <SmoothScrollLink
                      offset={0}
                      link_id={button[0].button_css_id || ""}
                      offsetMobile={0}
                      id={button[0].link as string}
                    >
                      <button className="rula-button">
                        {button[0].text || "Get started"}
                      </button>
                    </SmoothScrollLink>
                  </div>
                ) : (
                  <div>
                    <a
                      id={button[0]?.button_css_id || ""}
                      href={button[0]?.link}
                    >
                      <button className="rula-button">
                        {button[0]?.text || "Get Started"}
                      </button>
                    </a>
                  </div>
                )
              ) : null}
              {button[1] ? (
                <div className="link-container">
                  <SmoothScrollLink
                    id={button[1]?.link || "#how-it-works"}
                    className="rula-secondary-button"
                    link_id={button[1]?.button_css_id}
                    offset={100}
                    offsetMobile={75}
                  >
                    {button[1]?.text}
                    <img
                      className="link-arrow-button"
                      src={ArrowCircleDown}
                      alt="arrow downwards"
                    />
                  </SmoothScrollLink>
                </div>
              ) : null}
            </div>
          </div>
          <div className="landscape-hero-right-col">
            <div className="landscape-hero-image-container">
              <img
                className="landscape-hero-image"
                src={image[0]?.image?.fileUrl}
                alt={image[0]?.image?.altText}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="landscape-hero-partners">
        <PartnerBanner section={partnerSection} theme="white" responsive={true} buttonText="More partners" />
      </div>
    </header>
  );
};

export default LandscapeHero;
